var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 6.88293C16.8282 2.82634 13.1955 1 10.0045 1C10.0045 1 10.0045 1 9.99549 1C6.81351 1 3.17181 2.81756 2.22533 6.87415C1.17068 11.4049 4.01914 15.242 6.59717 17.6566C7.55267 18.5522 8.77859 19 10.0045 19C11.2304 19 12.4563 18.5522 13.4028 17.6566C15.9809 15.242 18.8293 11.4137 17.7747 6.88293ZM10.0045 11.282C8.43605 11.282 7.16506 10.0439 7.16506 8.5161C7.16506 6.98829 8.43605 5.75024 10.0045 5.75024C11.573 5.75024 12.8439 6.98829 12.8439 8.5161C12.8439 10.0439 11.573 11.282 10.0045 11.282Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon_address.c8b00ee92982f34084c3d2b8e14eb7dc.svg";
export { ForwardRef as ReactComponent };